import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SCSS_COLORS } from '../../../../../../../colors';

@Component({
  selector: 'lp2-group-class-state-signed-up',
  styleUrls: ['./group-class-state.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="divider mt-2 mt-sm-3"></div>
    <div class="d-flex justify-content-center align-items-center p-4 my-3">
      <lp2-animated-circle-icon
        [backgroundColor]="colors['$skeleton-grey']"
        [color]="colors['$dark-grey-medium']"
        [rippleColor]="colors['$private-class-light-blue']"
        width="42"
        height="42"
      >
        <i class="fa fa-user"></i>
      </lp2-animated-circle-icon>
      <p class="flex-1 m-0 ml-4 fw-bold state-text">{{ stateTextKey | translate }}</p>
    </div>
  `,
})
export class GroupClassStateSignedUpComponent {
  @Input() stateTextKey: string;
  public colors = SCSS_COLORS;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state-signed-up.component.ts